
import Vue from "vue";
import { ExtraFieldNamesConfig } from "../models/dossier-configs/extra-field-names-config";
import { getExtraFieldKeyNames, IExtraFields } from "../utils/models/extra-fields";
import AppLabel from "@/components/common/InfoInput.vue";
import { ExtraFieldNumberConfig } from "@/models/dossier-configs/extra-field-number-config";
import { ExtraFieldsTextInputType, ExtraFieldTextConfig } from "@/models/dossier-configs/extra-field-text-config";
import { ExtraFieldBaseConfig } from "@/models/dossier-configs/extra-field-base-config";

export default Vue.extend({
	data(){
		return {
			settings: [] as any
		};
	},
	props: {
		value: {
			type: Object as () => IExtraFields,
			required: true
		},
		nameSettings: {
			type: Object as () => ExtraFieldNamesConfig,
			required: true
		},
		saleTypeId: Number,
		tabId: {
			type: String as () => string | null,
			default: null
		}
	},
	computed: {
		locale(): string {
			return this.$i18n.locale;
		},
		numKeys():(keyof IExtraFields)[] {
			return getExtraFieldKeyNames("Num", this.nameSettings.NumOrder);
		},
		textKeys():(keyof IExtraFields)[] {
			return getExtraFieldKeyNames("Text", this.nameSettings.TextOrder).filter(k=>!this.hasFormatting(k));
		},
		formattedTextKeys():(keyof IExtraFields)[] {
			return getExtraFieldKeyNames("Text", this.nameSettings.TextOrder).filter(k=>this.hasFormatting(k));
		},
		boolKeys():(keyof IExtraFields)[] {
			return getExtraFieldKeyNames("Bool", this.nameSettings.BoolOrder);
		},
		timeKeys():(keyof IExtraFields)[] {
			return getExtraFieldKeyNames("Time", this.nameSettings.TimeOrder);
		}
	},
	methods: {
		getLabel(key:keyof ExtraFieldNamesConfig): string {
			if ((this.nameSettings[key] as string) != "") {
				return this.nameSettings[key] as string;
			}
			return key;
		},
		isActive(key:keyof IExtraFields): boolean {
			if (this.nameSettings[key] == "") return false;
			let conf = this.nameSettings[`${key}Config` as keyof ExtraFieldNamesConfig] as any as ExtraFieldBaseConfig;
			if (!conf) return true;
			if (this.saleTypeId) {
				if (conf.OnlyShownForSaleTypes.length > 0 && conf.OnlyShownForSaleTypes.indexOf(this.saleTypeId) == -1){
					return false;
				}
			}
			if (conf.HideInEditAndInfo) return false;
			return this.matchesTab(conf);
		},
		matchesTab(conf:ExtraFieldBaseConfig):boolean {
			if (this.tabId === null) return true;
			return (conf.TabID || "") == this.tabId;
		},
		hasFormatting(key:keyof IExtraFields):boolean {
			let conf = this.nameSettings[`${key}Config` as keyof ExtraFieldNamesConfig] as any as ExtraFieldTextConfig;
			return !!conf && conf.WithFormatting && conf.InputType == ExtraFieldsTextInputType.DEFAULT;
		},
		printDate(date:Date):string{
			if (date == null){
				return this.$ct("common.empty").toString();
			}
			return date.toLocaleDateString("nl-be", { year: "numeric", month: "2-digit", day: "2-digit" });
		},
		getDecimalsOfKey(key:keyof IExtraFields){
			return (this.nameSettings[`${key}Config` as keyof ExtraFieldNamesConfig] as ExtraFieldNumberConfig).Decimals;
		},
		getTextValue(val:string, key:string):string{
			let settings = ((this.nameSettings as any)[key + "Config"] as ExtraFieldTextConfig);
			if (!settings) return val;
			return settings.printValue(val);
		}
	},
	components: {
		AppLabel
	},
	i18nEx: {
		componentPrefix: "components.ExtraFieldsEdit"
	}
});
